import { render, staticRenderFns } from "./allocation_tiers.vue?vue&type=template&id=ad2d13dc&scoped=true&"
import script from "./allocation_tiers.vue?vue&type=script&lang=js&"
export * from "./allocation_tiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2d13dc",
  null
  
)

export default component.exports